import {cDisplay} from '../creator/cDisplay'
import { infoBubble } from '../creator/cDisplayObjects/infoBubble';
import { cGame } from '../creator/cGame';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { net } from '../creator/utils/net';


export class backpackDisplay extends cDisplay {

  private MAX_PAGES: number = 57;
  private curIndex: number = 1;

  init(){
    super.init()
    console.log('INIT BACKPACK', (this.scene as cScene).customeOptions);

    // var newOpt:any = (this.scene as cScene).customeOptions;
    // if (newOpt && newOpt.new_sticker){
    //   cGame.current.state.set('backpack_'+newOpt.new_sticker,1);
    // }

    (this.scene as cScene).ev.addListener('action',(type,action)=>{

      switch (action.command){
        case 'show_stickers':
          var h:cContainer = (this.scene as cScene).getByName('sticker_holder');
          var DATA:cSprite = (this.scene as cScene).getByName('DATA').modules.data._extraData;
          console.log(DATA);

          h.getAll().forEach((el)=>{
            console.log(el.name);
            var st = cGame.current.state.get(el.name,0);
            (el as cSprite).visible = (st == 1)
          });

          var newSticker = (this.scene as cScene).getState('new_sticker');
          if (newSticker != ''){

            var ref:cSprite = h.getByName('sticker_'+newSticker) as cSprite;
  
            var options = {
              value:DATA[newSticker],
              ofs: ref.x + 'x' + (ref.y-120),
              dir:'down',
              stalk:50
            }
            let hi = new infoBubble(this.scene as cScene,options, ()=>{
              
            })
            
            h.add(hi);
          }
          //(this.scene as cScene).setState('new_sticker','');

          break;
      }

    })

    setTimeout( ()=>{
    },1)

  }

  buildScene(){    
    super.buildScene();      
  }

}
